import React  from "react";
import { useParams } from 'react-router-dom';
import { Card } from "antd";
import StartReviewForm from "./components/StartReviewForm";

const StartReview = () => {

	const {  } = useParams();

	return (
			<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<StartReviewForm/>
			</div>
    );
};

export default StartReview;